import styled from 'styled-components';

export const DefaultColorPalette = [
  '#0218a2',
  '#ffb703',
  '#f76f73',
  '#027fdc',
  '#07c4c5',
  '#ffe196',
  '#d8b5b5'
];

export const ChartPageContainer = styled.div`
  width: 100%;
  padding: 1em;
  display: flex;
  flex-wrap: wrap-reverse;
`;

export const ChartContainer = styled.div`
  width: 75%;
  min-height: 600px;
  marginRight: 1em;
  @media(max-width: 1000px) {
    width: 100%;
    min-height: 400px;
  }
`;

export const ChartHeader = styled.div`
  width: 100%;
  text-align: center;
  font-weight: bold;
}`;

export const ChartBodyContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: flex-start;
  align-items: stretch;
`;

export const ChartYAxisLabel = styled.div`
  display: flex;
  align-items: center;
  width: 20px;
  transform: rotate(-90deg);
  white-space: nowrap;
`;

export const ChartBody = styled.div`
  color: #fff;
  height: 600px;
  width: 100%;
  z-index: 100;
`;

export const ChartXAxisLabel = styled.div`
  width: 100%;
  height: auto;
  text-align: center;
}`;
